import { ConnectedDeviceGroups, ConnectedSystems } from 'components';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { usePerms } from 'contexts/PermsContext';
import DeviceSettingsModals from 'features/Integrations/features/ConnectedDevices/features/DeviceList/DeviceModals/DeviceSettingsModals';
import { fetchIntegrationThunk } from 'features/Integrations/state/thunks/integrationThunks.js';
import useWindow from 'hooks/useWindow';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Devices from './ConnectedDevices/ConnectedDevices.jsx';

export default function Integrations() {
  const [params] = useSearchParams();
  const perms = usePerms();
  const dispatch = useDispatch();
  const { width } = useWindow();
  const compactLayout = width < 768;

  useEffect(() => {
    dispatch(fetchIntegrationThunk());
  }, [dispatch]);

  const topTabs = perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewDeviceGroups'])
    ? [
        { option: 'Connected Systems' },
        { option: 'Connected Devices' },
        { option: 'Connected Device Groups' },
      ]
    : [{ option: 'Connected Systems' }, { option: 'Connected Devices' }];

  // Wait for permissions to load before rendering headers or tabs
  if (perms.isFetching || perms.data == null) return <WidgetLoadingAnimation />;

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'connected systems':
        return (
          <div
            id="connected-systems"
            className="d-flex flex-column flex-grow-1 w-100 h-100 min-h-0 overflow-hidden"
          >
            <ConnectedSystems />
          </div>
        );
      case 'connected devices':
        return (
          <div
            id="connected-devices"
            className={
              compactLayout
                ? 'd-flex flex-column w-100'
                : 'd-flex flex-column flex-grow-1 w-100 h-100 min-h-0'
            }
          >
            <Devices />
          </div>
        );
      case 'connected device groups':
        return (
          <div
            id="connected-device-groups"
            className="d-flex flex-column flex-grow-1 w-100 h-100 min-h-0 overflow-hidden"
          >
            <ConnectedDeviceGroups />
          </div>
        );
      default:
        return (
          <div
            id="connected-systems"
            className="d-flex flex-column flex-grow-1 w-100 h-100 min-h-0 overflow-hidden"
          >
            <ConnectedSystems />
          </div>
        );
    }
  };

  return (
    <>
      <Container
        fluid
        className={
          compactLayout
            ? 'integrations-page-shell w-100 d-flex flex-column gap-3 overflow-visible'
            : 'integrations-page-shell h-100 min-h-0 w-100 d-flex flex-column gap-3 overflow-hidden'
        }
      >
        <div className="d-none d-lg-flex">
          <TabsHeader options={topTabs} />
        </div>
        <div className="d-lg-none w-100">
          <MobileTabsHeader options={topTabs} />
        </div>
        <div
          className={
            compactLayout
              ? 'integrations-tab-content pb-3 d-flex'
              : 'integrations-tab-content pb-3 flex-fill d-flex min-h-0'
          }
        >
          {renderTab()}
        </div>
      </Container>

      <DeviceSettingsModals />
    </>
  );
}
